var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrailer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3590_38534",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3590_38534)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 20C8.16667 20 7.45833 19.7083 6.875 19.125C6.29167 18.5417 6 17.8333 6 17H4V6C4 5.45 4.19583 4.97917 4.5875 4.5875C4.97917 4.19583 5.45 4 6 4H20V8V15V15.5V16V16.5V17V20H18V17H12C12 17.8333 11.7083 18.5417 11.125 19.125C10.5417 19.7083 9.83333 20 9 20ZM9 18C9.28333 18 9.52083 17.9042 9.7125 17.7125C9.90417 17.5208 10 17.2833 10 17C10 16.7167 9.90417 16.4792 9.7125 16.2875C9.52083 16.0958 9.28333 16 9 16C8.71667 16 8.47917 16.0958 8.2875 16.2875C8.09583 16.4792 8 16.7167 8 17C8 17.2833 8.09583 17.5208 8.2875 17.7125C8.47917 17.9042 8.71667 18 9 18Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrailer);
export default __webpack_public_path__ + "static/media/trailer.6de9a33e1a030d4edb20bc6c6afa058c.svg";
export { ForwardRef as ReactComponent };